import { number, object, ObjectSchema, mixed } from "yup";
import type { DemographicsCategory, Options } from "./types";

export const schema: ObjectSchema<Options> = object({
  lat: number()
    .min(-90, "Must be a valid latitude.")
    .max(90, "Must be a valid latitude.")
    .required(),
  lng: number()
    .min(-180, "Must be a valid longitude.")
    .max(180, "Must be a valid longitude.")
    .required(),
  title: mixed<string | boolean>().optional(),
  defaultTab: mixed<DemographicsCategory>().optional(),
}).noUnknown(true);

export const validateOptions = (options: Options) =>
  schema.validate(options, { abortEarly: false });
